import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/map-point.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-36902ce8")

_pushScopeId("data-v-36902ce8")
const _hoisted_1 = { class: "home-about" }
const _hoisted_2 = { class: "home-about__wrap" }
const _hoisted_3 = { class: "home-about__text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "home-about__img",
  alt: "Карта мира",
  title: "Рост количества зарегистрированных иностранных туристов в Казахстане"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.items, (item, itemInd) => {
        return (_openBlock(), _createBlock("div", {
          key: itemInd,
          style: { transform: `translateY(${item.y})` },
          class: "home-about__item"
        }, [
          _createVNode("div", {
            style: { backgroundColor: item.color },
            class: "home-about__icon"
          }, [
            _createVNode("img", {
              src: item.icon,
              alt: item.alt,
              title: item.title
            }, null, 8, ["src", "alt", "title"])
          ], 4),
          _createVNode("div", {
            style: { height: item.height, backgroundColor: item.color },
            class: "home-about__line"
          }, null, 4),
          _createVNode("div", {
            style: { backgroundColor: item.color },
            class: "home-about__circle"
          }, null, 4),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(item.text)), 1)
        ], 4))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _hoisted_4
  ]))
})